import React from 'react';
import type { SegmentDefinitionSummary } from '../../edit-automation-template/segment-definitions-api';
import { SegmentTableRow } from './SegmentTableRow';
import { SegmentsTableEmpty } from './SegmentsTableEmpty';
import styles from './SegmentsTable.module.css';

interface SegmentsTableProps {
  segments: SegmentDefinitionSummary[];
}

export const SegmentsTable: React.FC<SegmentsTableProps> = ({ segments }) => {
  if (segments.length === 0) {
    return <SegmentsTableEmpty />;
  }

  return (
    <div className="overflow-x-auto">
      <table className={styles.segmentsTable}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Last Modified</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {segments.map((segment: SegmentDefinitionSummary) => (
            <SegmentTableRow key={segment.id} segment={segment} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
